import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import ClientProfileDetails from "../client-profile-details";
import ClientProfileHeader from "../client-profile-header";
import CustomFields from "../custom-fields";
import InactiveProfileBar from "../inactive-profile-bar";
import StatesBar from "../states-bar";
import LinkedApplications from "../linked-applications";
import NotifiedReferrers from "../notified-referrers";
import Participants from "../participants";
import UploadedDocuments from "../uploaded-documents";
import ClientProfileLists from "../client-profile-lists.vue";
import ClientProfileCampaigns from "../client-profile-campaigns.vue";
import ActionsPanel from "../actions-panel";
import TimelineContainer from "./timeline-container";
import DuplicateClientProfileModal from "../duplicate-client-profile-modal";
import MergeClientProfileModal from "../merge-client-profile-modal";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { LOAD_CLIENT_DATA } from "../../../../applications/application/store/application-actions";
import CoApplicantsInfo from "../co-applicants-info";
import { difference, scrollTop } from "@Shared/utils/utils";
import { LOAD_EMAIL_TEMPLATES, LOAD_CLIENT_PROFILE_SUBSCRIBERS, LOAD_CUSTOM_FIELDS_DEFINITIONS, UPDATE_BOARD_PROFILE, SAVE_PROFILE_DETAILS, MERGE_CUSTOM_FIELDS_DATA, ASSIGN_REFERRER, SUBSCRIBE_REFERRER, LOAD_CHANGELOG, DUPLICATE_CLIENT_PROFILE, MERGE_CLIENT_PROFILE, LOAD_TIMELINE, CACHED_CLIENT_PROFILE_DATA, LOAD_CLIENT_PROFILE_DETAILS, UPDATE_PROFILE_LABEL, TRANSFER_CLIENT_PROFILE } from "../../../store/board-actions";
import { CUSTOM_FIELDS_DEFINITIONS } from "@Broker/@Modules/clients/board/store/board-getters";
import Err from "../../../../../../routes/error";
import { CREATE_REFERRER, LOAD_REFERRERS, UPDATE_REFERRER } from "@Broker/js/modules/clients/referrers/store/referrer-actions";
import ManageReferrerModal from "@Broker/@Modules/clients/referrers/components/manage-referrer-modal.vue";
import { showToast } from "@Shared/@Utils/constants";
import StarredLinkedApplication from "@Broker/@Modules/clients/board/client-profile/components/starred-linked-application.vue";
import ActiveToggleModal from "../client-profile-active-toggle-modal";
import ClientProfileMasterUnsubscribeConfirmation from "../client-profile-master-unsubscribe-confirmation";
import CopyApplicationModal from "../../../../applications/application/applications-list/components/copy-application-modal";
import { COPY_APPLICATION } from "../../../../applications/application/applications-list/store/applications-list-actions";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { LOAD_SYNCED_EMAILS } from "@Broker/@Modules/settings/store/settings-actions";
import { LOAD_EMAIL_SIGNATURE } from "@Broker/@Modules/main/store/account/account-actions";
import { cloneDeep, debounce, isEmpty, omit, values } from "lodash";
import { SET_PROFILE_STRUCTURE } from "../../../store/board-mutations";
import { mapCacheActions } from "vuex-cache";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfileContainer",
  title() {
    return this.$t("sidebar.sections.clientProfile");
  },
  components: {
    CoApplicantsInfo,
    ClientProfileHeader,
    ClientProfileDetails,
    InactiveProfileBar,
    StatesBar,
    LinkedApplications,
    NotifiedReferrers,
    CustomFields,
    UploadedDocuments,
    ActionsPanel,
    TimelineContainer,
    ManageReferrerModal,
    DuplicateClientProfileModal,
    StarredLinkedApplication,
    MergeClientProfileModal,
    ActiveToggleModal,
    ClientProfileLists,
    ClientProfileCampaigns,
    ClientProfileMasterUnsubscribeConfirmation,
    CopyApplicationModal,
    Participants
  },
  props: {
    back: {
      type: String,
      default: ""
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    location: {
      type: String,
      default: ""
    },
    boardId: {
      type: [String, Number],
      default: null
    },
    moved: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      silentLoading: false,
      loadingChangelog: false,
      tabData: {},
      currentTab: "note",
      saving: false,
      initialProfile: {},
      loadingCustomFields: true,
      selectedReferrer: {},
      selectedReferrerType: "",
      submittingReferrer: {
        loading: false,
        status: true
      },
      states: [],
      timelineTab: "",
      duplicatingClientProfile: false,
      duplicateAndPin: false,
      currentApplicationIdForDuplication: "",
      mergingClientProfile: false,
      accountUsername: this.CURRENT_USER_USERNAME,
      applicationStreet: "",
      applicationId: "",
      clientUsername: "",
      agent: "",
      currentAddress: null,
      documentCount: 0,
      limit: 20,
      offset: 0,
      loadingMoreTimeline: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [CUSTOM_FIELDS_DEFINITIONS, "progressStates", "filterTimelineList"])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), mapState("BoardStore", {
    profile(state) {
      return state.clientProfiles.byId[this.clientProfileId] || {};
    }
  })), mapState("ReferrerStore", ["referrers"])), mapState("ApplicationStore", {
    applications(state) {
      return this.username && state.clients[this.username] ? state.clients[this.username].applications.byId : {};
    }
  })), {}, {
    referrerValues() {
      var _context;
      return _mapInstanceProperty(_context = this.referrers.allIds).call(_context, referrerId => this.referrers.byId[referrerId]);
    },
    customFieldsDefinitions() {
      return this.CUSTOM_FIELDS_DEFINITIONS(this.boardIdToUse);
    },
    boardIdToUse() {
      var _statusLabels$0$board, _statusLabels$;
      if (this.boardId) return this.boardId;
      const {
        statusLabels
      } = this.profile;
      return (_statusLabels$0$board = statusLabels == null ? void 0 : (_statusLabels$ = statusLabels[0]) == null ? void 0 : _statusLabels$.boardId) != null ? _statusLabels$0$board : "";
    },
    username() {
      var _this$profile;
      return ((_this$profile = this.profile) == null ? void 0 : _this$profile.linkedAccountUsername) || "";
    },
    documents() {
      var _this$profile$timelin;
      const timelineItems = values((_this$profile$timelin = this.profile.timeline) == null ? void 0 : _this$profile$timelin.byId);
      return _filterInstanceProperty(timelineItems).call(timelineItems, item => item.activityType === "file");
    },
    starredApplication() {
      var _this$profile2;
      return this.applications[(_this$profile2 = this.profile) == null ? void 0 : _this$profile2.starredApplicationId] || null;
    },
    currentAddressObjLength() {
      return this.currentAddress ? _Object$keys(this.currentAddress).length : 0;
    }
  }),
  watch: {
    username(val) {
      if (val) {
        this.LOAD_CLIENT_DATA({
          clientUsername: this.username,
          agentUsername: this.agentUsername,
          clientProfileId: this.clientProfileId
        });
      }
    },
    boardId() {
      this.loadCustomFields();
    },
    //if it has boardName key, it means LOAD_BOARD_CLIENTS action was called,
    //so we need to reset the initialProfile.
    profile: {
      handler(profile) {
        if (profile.boardName) this.initialProfile = cloneDeep(profile);
      },
      deep: true
    }
  },
  mounted() {
    this.handleScroll();
  },
  activated() {
    this.SET_PROFILE_STRUCTURE(this.clientProfileId);
    this.currentTab = "note";
    window.addEventListener("beforeunload", this.confirmExit);
    Amplitude.logEvent("Client Profile - visited");
    this.init();
  },
  deactivated() {
    this.offset = 0;
    window.removeEventListener("beforeunload", this.confirmExit);
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.confirmExit);
    $("#single-client-profile-page").off("scroll.timeline-infinite-scroll");
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_CLIENT_DATA])), mapActions("ReferrerStore", [LOAD_REFERRERS, CREATE_REFERRER, UPDATE_REFERRER])), mapActions("BoardStore", [LOAD_CUSTOM_FIELDS_DEFINITIONS, UPDATE_BOARD_PROFILE, SAVE_PROFILE_DETAILS, MERGE_CUSTOM_FIELDS_DATA, ASSIGN_REFERRER, SUBSCRIBE_REFERRER, LOAD_CHANGELOG, DUPLICATE_CLIENT_PROFILE, MERGE_CLIENT_PROFILE, LOAD_TIMELINE, LOAD_EMAIL_TEMPLATES, LOAD_CLIENT_PROFILE_SUBSCRIBERS, LOAD_CLIENT_PROFILE_DETAILS, UPDATE_PROFILE_LABEL, TRANSFER_CLIENT_PROFILE])), mapCacheActions("BoardStore", [CACHED_CLIENT_PROFILE_DATA])), mapActions("SettingsStore", [LOAD_SYNCED_EMAILS])), mapActions("AccountStore", [LOAD_EMAIL_SIGNATURE])), mapMutations("BoardStore", [SET_PROFILE_STRUCTURE])), mapActions("ApplicationsListStore", [COPY_APPLICATION])), {}, {
    async init() {
      this.loading = true;
      await this.CACHED_CLIENT_PROFILE_DATA({
        clientProfileId: this.clientProfileId
      });
      await _Promise.all([this.LOAD_SYNCED_EMAILS(), this.LOAD_EMAIL_SIGNATURE()]);
      if (this.username) {
        await this.LOAD_CLIENT_DATA({
          clientUsername: this.username,
          agentUsername: this.agentUsername,
          clientProfileId: this.clientProfileId
        });
      }
      this.initialProfile = cloneDeep(this.profile);
      this.states = this.progressStates(this.clientProfileId);
      this.loadCustomFields();
      await this.LOAD_CLIENT_PROFILE_SUBSCRIBERS({
        clientProfileId: this.clientProfileId
      });
      await this.LOAD_REFERRERS({
        clientProfileId: this.clientProfileId
      });
      this.loading = false;
    },
    async loadCustomFields() {
      this.loadingCustomFields = true;
      await this.LOAD_CUSTOM_FIELDS_DEFINITIONS({
        boardId: this.boardIdToUse
      });
      await this.MERGE_CUSTOM_FIELDS_DATA({
        clientProfileId: this.clientProfileId,
        customFieldsDefinitions: this.customFieldsDefinitions
      });
      this.loadingCustomFields = false;
    },
    handleScroll() {
      $("#single-client-profile-page").on("scroll.timeline-infinite-scroll", event => {
        if (!this.loadingMoreTimeline && this.profile.timelineActivityLeft > 0 && this.profile.timelineActivityLeft >= this.limit) {
          const scroller = $(event.currentTarget);
          if (scroller.scrollTop() + scroller.innerHeight() >= scroller[0].scrollHeight - 200) {
            this.loadMoreTimeline();
          }
        }
      });
    },
    async loadMoreTimeline() {
      try {
        this.loadingMoreTimeline = true;
        this.offset += this.limit;
        await this.LOAD_TIMELINE({
          id: this.clientProfileId,
          limit: this.limit,
          offset: this.offset
        });
      } catch (e) {
        console.error("Error during Timeline loading", e);
      } finally {
        this.loadingMoreTimeline = false;
      }
    },
    confirmExit(event) {
      const keysToOmit = ["linkedAccountUsername", "trackEmails", "owner", "updatedAt", "status", "statusLabelId", "active", "nonEmptyDOB", "customFields", "closingDate", "renewalDate", "upcomingDate", "starredApplicationId", "boards", "changelog", "emailSignature", "emails", "isEmailSynced", "notifiedReferrers", "referrers", "statusLabels", "timeline", "masterUnsubscribed", "authorUnsubscribed"];
      const differences = difference(this.profile, this.initialProfile);
      const confirm = this.saving || !isEmpty(omit(differences, keysToOmit));
      if (confirm) {
        const confirmationMessage = this.$t("global.phrases.youHaveUnsavedChanges");
        event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
        return confirmationMessage; // Gecko, WebKit, Chrome <34
      }
    },
    changeAction(action, data = {}) {
      this.currentTab = action;
      this.tabData = data;
    },
    handleSave: debounce(function () {
      this.fireSave();
    }, 500),
    async fireSave() {
      try {
        this.saving = true;
        await this.SAVE_PROFILE_DETAILS({
          id: this.clientProfileId
        });
        this.UPDATE_BOARD_PROFILE({
          clientProfileId: this.clientProfileId,
          details: this.profile
        });
        const applicationWasStarred = !this.initialProfile.starredApplicationId && this.profile.starredApplicationId;
        if (this.profile.email !== this.initialProfile.email) this.reloadProfileData({
          silent: true
        });
        if (applicationWasStarred) scrollTop("#page");
        this.initialProfile = cloneDeep(this.profile);
        if (this.timelineTab === "changelog") this.loadChangelog();
      } catch (error) {
        const {
          message
        } = error.responseJSON || {
          message: this.$t("notification-messages.errorSavingYourDetails")
        };
        Err.handle(error, {}, message);
        Amplitude.logHandledError(error, {}, message);
      } finally {
        this.saving = false;
      }
    },
    async handleReferrerSubmit({
      referrer,
      create
    }) {
      const referrerId = await this.submitReferrer(referrer);
      if (referrerId && this.selectedReferrerType !== "notified") {
        await this.ASSIGN_REFERRER({
          profileId: this.clientProfileId,
          referrerId
        });
        this.handleSave();
      }
      if (this.selectedReferrerType === "notified") {
        this.subscribeReferrer(this.referrers.byId[referrerId]);
      }
      if (!create) {
        await this.LOAD_CLIENT_PROFILE_DETAILS({
          clientProfileId: this.clientProfileId
        });
      }
    },
    async subscribeReferrer(referrer) {
      const subscription = {
        subscriberId: referrer.id,
        subscriberOptions: {
          statusChange: true
        }
      };
      this.SUBSCRIBE_REFERRER({
        id: this.clientProfileId,
        subscribers: [subscription],
        referrers: [referrer]
      });
    },
    async submitReferrer(referrer) {
      let referrerId;
      try {
        this.submittingReferrer.loading = true;
        if (referrer.id) {
          await this.UPDATE_REFERRER({
            referrer,
            referrerId: referrer.id
          });
        } else {
          const response = await this.CREATE_REFERRER({
            referrer
          });
          referrerId = response == null ? void 0 : response.referrerId;
          showToast("success", "referrerCreated");
        }
        this.submittingReferrer.status = true;
        this.$refs.referrersModal.hideModal();
        return referrerId;
      } catch (_unused) {
        this.submittingReferrer.status = false;
      } finally {
        this.submittingReferrer.loading = false;
      }
    },
    handleReferrers(referrerId, referrerData, type) {
      var _ref;
      const referrerDetails = (_ref = referrerData != null ? referrerData : this.referrers.byId[referrerId]) != null ? _ref : {};
      this.selectedReferrerType = type;
      this.$set(this, "selectedReferrer", referrerDetails);
      this.$refs.referrersModal.showModal();
    },
    async loadChangelog() {
      this.loadingChangelog = true;
      await this.LOAD_CHANGELOG({
        clientProfileId: this.clientProfileId
      });
      this.loadingChangelog = false;
    },
    async handleDuplicateClientProfile({
      labelColor,
      labelText,
      boardId,
      isEditingLabel,
      addingLabel
    }) {
      this.duplicatingClientProfile = true;
      if (this.profile.labelText && isEditingLabel || addingLabel) {
        await this.UPDATE_PROFILE_LABEL({
          clientProfileId: this.clientProfileId,
          labelColor,
          labelText
        });
        this.duplicatingClientProfile = false;
        if (boardId && this.boardId != boardId) {
          try {
            this.$refs.duplicateModal.hideModal();
            await this.TRANSFER_CLIENT_PROFILE({
              id: this.clientProfileId,
              statusLabelId: this.initialProfile.statusLabelId,
              boardId,
              inactive: false
            });
          } catch (error) {
            console.error(error);
          }
          this.$router.push({
            name: "client-profile",
            params: {
              boardId: this.boardIdToUse,
              clientProfileId: this.clientProfileId
            }
          });
        } else {
          window.location.reload();
        }
      } else {
        const duplicatedClientProfileId = await this.DUPLICATE_CLIENT_PROFILE({
          clientProfileId: this.clientProfileId,
          applicationId: this.currentApplicationIdForDuplication,
          labelColor,
          labelText
        });
        this.duplicatingClientProfile = false;
        if (!duplicatedClientProfileId) return;
        this.$refs.duplicateModal.hideModal();
        if (boardId) {
          try {
            await this.TRANSFER_CLIENT_PROFILE({
              id: duplicatedClientProfileId,
              statusLabelId: this.initialProfile.statusLabelId,
              boardId,
              inactive: false
            });
          } catch (error) {
            console.error(error);
          }
        }
        this.$router.push({
          name: "client-profile",
          params: {
            boardId: this.boardIdToUse,
            clientProfileId: duplicatedClientProfileId
          }
        });
      }
    },
    setDuplicateProfileModalData({
      pin,
      applicationId
    }) {
      this.duplicateAndPin = pin;
      this.currentApplicationIdForDuplication = applicationId;
    },
    resetDuplicateProfileModalData() {
      this.duplicateAndPin = false;
      this.currentApplicationIdForDuplication = "";
    },
    async handleMergeClientProfile({
      mergeData,
      secondClientProfileId
    }) {
      this.mergingClientProfile = true;
      const {
        succeeded
      } = await this.MERGE_CLIENT_PROFILE({
        clientProfileId: this.clientProfileId,
        secondClientProfileId,
        mergeData
      });
      this.mergingClientProfile = false;
      if (!succeeded) return;
      this.$refs.mergeModal.hideModal();
      this.reloadProfileData();
    },
    async reloadProfileData({
      silent = false
    }) {
      var _this$profile3;
      if (!silent) this.loading = true;else this.silentLoading = true;
      await _Promise.all([this.LOAD_CLIENT_PROFILE_DETAILS({
        clientProfileId: this.clientProfileId
      }), this.LOAD_TIMELINE({
        id: this.clientProfileId,
        offset: 0,
        limit: 20
      })]);
      if ((_this$profile3 = this.profile) != null && _this$profile3.linkedAccountUsername) {
        //Needs to be called after loading client profile details.
        await this.LOAD_CLIENT_DATA({
          clientUsername: this.username,
          agentUsername: this.agentUsername,
          clientProfileId: this.clientProfileId
        });
      }
      this.loading = false;
      this.silentLoading = false;
    },
    showActiveToggleModal() {
      this.$refs.activeToggleModal.$showModal();
    },
    async copyApplication({
      copyAsCurrentAddress = null,
      copyAsPropertyOwned = null,
      copyAsPreviousAddress = null,
      copyDocuments = null
    }) {
      const details = await this.COPY_APPLICATION({
        data: {
          copyItems: ["all"],
          copyFromApplicationId: _parseInt(this.applicationId),
          copyAsCurrentAddress,
          copyAsPropertyOwned,
          copyAsPreviousAddress,
          copyDocuments
        },
        clientUsername: this.username,
        agentUsername: this.agent,
        clientProfileId: this.clientProfileId
      });
      this.redirectToApplication(details);
    },
    redirectToApplication({
      clientUsername,
      applicationId,
      agentUsername
    }) {
      this.$router.replace({
        name: "application",
        params: {
          clientUsername,
          applicationId,
          agentUsername
        }
      });
    },
    handleCopyApplication(application) {
      this.applicationStreet = application.propertyAddress;
      this.applicationId = application.applicationId;
      this.clientUsername = application.clientUsername;
      this.agent = application.agentUsername;
      this.documentCount = _parseInt(this.applications[application.applicationId].documentCount);
      this.currentAddress = this.applications[application.applicationId].currentMainApplicantAddress;
      if (!this.applicationStreet && this.currentAddressObjLength <= 1 && this.documentCount == 0) {
        this.copyApplication({
          copyAsCurrentAddress: false,
          copyAsPropertyOwned: false,
          copyAsPreviousAddress: false,
          copyDocuments: false
        });
        return;
      }
      showBModal("copy-application-modal", {}, this);
    },
    showDuplicateProfileModal(isEditingLabel = false, addingLabel = false) {
      this.setDuplicateProfileModalData({
        pin: this.duplicateAndPin,
        applicationId: this.currentApplicationIdForDuplication
      });
      this.$refs.duplicateModal.showModal(isEditingLabel, addingLabel);
    }
  })
});